import React, { useState } from "react";
import {
  useGetCompletedTasksByFamilyQuery,
  useDeleteTaskMutation,
  useUpdateTaskMutation,
} from "../api/taskApi";

import Button from "../components/UI/Button";
import { CardSimple } from "../components/UI/Card";
import Input from "../components/UI/Input";

type TransformedTask = {
  id: string;
  name: string;
  details: string;
  completed: boolean;
  comments?: string;
};

const CompletedTasksTable: React.FC = () => {
  const familyId = "38f35bbf-984b-461e-855a-309be68eb454"; 
  const { data: allTasks = [], error, isLoading } = useGetCompletedTasksByFamilyQuery({ familyId });

  const tasks = allTasks.filter((task) => task.completed);

  const [deleteTask] = useDeleteTaskMutation();
  const [updateTask] = useUpdateTaskMutation();
const [searchTerm, setSearchTerm] = useState("");
  const [editingTaskId, setEditingTaskId] = useState<string | null>(null);
  const [editValues, setEditValues] = useState({
    description: "",
    status: "הושלם" as "בתהליך" | "הושלם",
    comments: "",
  });

  const handleEdit = (task: TransformedTask) => {
    setEditingTaskId(task.id);
    setEditValues({
      description: task.name,
      status: task.completed ? "הושלם" : "בתהליך",
      comments: task.comments || "",
    });
  };

  const handleSave = async (task: TransformedTask) => {
    try {
      await updateTask({
        id: task.id,
        meeting_id: "", 
        family_id: familyId,
        description: editValues.description,
        status: editValues.status,
        comments: editValues.comments,
      }).unwrap();
      alert("המשימה עודכנה בהצלחה");
      setEditingTaskId(null);
    } catch {
      alert("שגיאה בעדכון המשימה");
    }
  };

  const handleDelete = async (id: string) => {
    if (window.confirm("האם את בטוחה שברצונך למחוק משימה זו?")) {
      try {
        await deleteTask({ id }).unwrap();
        alert("המשימה נמחקה בהצלחה");
      } catch {
        alert("שגיאה במחיקת המשימה");
      }
    }
  };

  if (isLoading) return <p>טוען משימות...</p>;
  if (error) return <p>שגיאה בטעינת המשימות</p>;

const filteredTasks = tasks.filter((task) =>
  task.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  (task.comments || "").toLowerCase().includes(searchTerm.toLowerCase())
);

  return (
    <CardSimple className="mt-6">
      <h2 className="text-xl font-semibold mb-4">טבלת משימות שהושלמו</h2>
<div className="mb-4">
  <Input
    placeholder="חיפוש לפי תיאור או הערות"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>
      {tasks.length > 0 ? (
        <table className="w-full table-auto border-collapse border border-border rounded-xl">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-border p-3 text-right">תיאור</th>
              <th className="border border-border p-3 text-right">סטטוס</th>
              <th className="border border-border p-3 text-right">הערות</th>
              <th className="border border-border p-3 text-center">פעולות</th>
            </tr>
          </thead>
          <tbody>
            {filteredTasks.map((task) => (
              <tr key={task.id} className="even:bg-gray-50">
                {editingTaskId === task.id ? (
                  <>
                    <td className="border border-border p-2">
                      <Input
                        value={editValues.description}
                        onChange={(e) =>
                          setEditValues({ ...editValues, description: e.target.value })
                        }
                        placeholder="תיאור המשימה"
                      />
                    </td>
                    <td className="border border-border p-2 text-center">
                      <select
                        className="rounded-xl border border-border px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
                        value={editValues.status}
                        onChange={(e) =>
                          setEditValues({
                            ...editValues,
                            status: e.target.value === "הושלם" ? "הושלם" : "בתהליך",
                          })
                        }
                      >
                        <option value="בתהליך">בתהליך</option>
                        <option value="הושלם">הושלם</option>
                      </select>
                    </td>
                    <td className="border border-border p-2">
                      <Input
                        value={editValues.comments}
                        onChange={(e) =>
                          setEditValues({ ...editValues, comments: e.target.value })
                        }
                        placeholder="הערות"
                      />
                    </td>
                    <td className="border border-border p-2 flex justify-center gap-2">
                      <Button size="sm" variant="primary-dark" onClick={() => handleSave(task)}>
                        שמירה
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => setEditingTaskId(null)}>
                        ביטול
                      </Button>
                    </td>
                  </>
                ) : (
                  <>
                    <td className="border border-border p-3">{task.name}</td>
                    <td className="border border-border p-3 text-center">{task.completed ? "הושלם" : "בתהליך"}</td>
                    <td className="border border-border p-3">{task.comments}</td>
                    <td className="border border-border p-3 flex justify-center gap-2">
                      <Button size="sm" variant="ghost" onClick={() => handleEdit(task)}>
                        עריכה
                      </Button>
                      <Button size="sm" variant="danger" onClick={() => handleDelete(task.id)}>
                        מחיקה
                      </Button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>לא נמצאו משימות שהושלמו</p>
      )}
    </CardSimple>
  );
};

export default CompletedTasksTable;
